import {
  ToastProvider,
  TranslationContext,
} from "@3sc/common-component";
import { createBrowserHistory } from "history";
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Network from "./components/Network";
import Routing from "./routers/Routing";
import "./style/sass/main.scss";
import { useTranslation } from "react-i18next";
import AnalyticsRouterSync from "./components/AnalyticsRouterSync";
import { user_metadata as user } from "./config/localStorage";

const defaultHistory = createBrowserHistory();

function App() {
  const { t } = useTranslation();

  useEffect(() => {
    window.__ANALYTICS__?.setUser(user);
  }, [user]);

  return (
    <div className="App">
      <BrowserRouter history={defaultHistory} basename="scai">
        <TranslationContext.Provider value={{ t }}>
          <ToastProvider>
            <AnalyticsRouterSync />
            <Layout>
              <Routing />
              <Network />
            </Layout>
          </ToastProvider>
        </TranslationContext.Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
